import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import {initialFilter} from "../../../../utils/UIHelpers";

const ResultManagerLabelUIContext = createContext();

export function useResultManagerLabelUIContext() {
  return useContext(ResultManagerLabelUIContext);
}

export function ResultManagerLabelUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParams,
  };

  return (
    <ResultManagerLabelUIContext.Provider value={value}>
      {children}
    </ResultManagerLabelUIContext.Provider>
  );
}
